/*
linkSettingRow.tsx
Copyright © 2026 Xerox Corporation. All Rights Reserved.

Copyright protection claimed includes all forms and matters of copyrightable material
and information now allowed by statutory or judicial law or hereinafter granted,
including without limitation, material generated from the software programs which
are displayed on the screen such as icons, screen display looks, etc.
*/

import { ReactNode } from 'react'

export interface LinkSettingRowProps {
  label: string
  displayValue?: string | ReactNode
  onClick(): void
  imagePath?: string
  glyphName?: string
}
export default function LinkSettingRow (props: LinkSettingRowProps) {
  const { label, displayValue, onClick, imagePath, glyphName } = props
  return (
    <>
      {imagePath || glyphName ? (
        <div
          className={`left-object custom-icon-rounded ${
            glyphName ? 'link-setting-glyph' : ''
          }`}
        >
          {imagePath ? (
            <img src={imagePath} className='img-fluid' />
          ) : (
            <i className={`${glyphName} xglsize-32`}></i>
          )}
        </div>
      ) : (
        <></>
      )}

      <div className='content-container' onClick={() => onClick()}>
        <div className='left-label col-5 pl-0'>
          <span>{label}</span>
        </div>
        {displayValue ? (
          <div className='right-object col-7 pr-0'>
            {typeof displayValue == 'string' || typeof displayValue == 'number' ? (
              <div className={`text-right feedback-label link-setting-row-display ${!imagePath && !glyphName ? "no-glyph" : ""}`}>
                <span>{displayValue}</span>
              </div>
            ) : (
              displayValue
            )}
          </div>
        ) : (
          <></>
        )}
      </div>
    </>
  )
}